export const CREATE_PROFILE = 'CREATE_PROFILE';
export const STOP_CREATE_PROFILE = 'STOP_CREATE_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const GET_SUBSCRIBERS = 'GET_SUBSCRIBERS';
export const PROFILE_CREATED = 'PROFILE_CREATED';
export const GET_LTE_KYC_CUSTOMERS = 'GET_LTE_KYC_CUSTOMERS';
export const UPLOAD_LTE_KYC_CUSTOMER = 'UPLOAD_LTE_KYC_CUSTOMER';
